// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.network_title__otc5C {
  text-align: center;
}

.network_network_info_container__J-lJ\\+ {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  background-color: #595959; /* 컨테이너 배경색 */
  width: 95%;
  color: #ffffff; /* 텍스트 색상 */
  padding: 20px;
  border-radius: 5px;
  margin: auto;
}

.network_network_info_container__J-lJ\\+ span {
  width: 100%;
}

.network_network_info_container__J-lJ\\+ h2 {
  text-align: center;
  color: #ffffff; /* 헤더 텍스트 색상 */
}

.network_network_info_box__ggnTC {
  background-color: #06B8F0; /* 박스 배경색 */
  color: #ffffff; /* 텍스트 색상 */
  padding: 10px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}

.network_network_info_box__ggnTC:hover {
  transform: scale(1.05);
}

.network_network_info_name__UfUPN {
  font-weight: bold;
  margin-bottom: 5px;
}

.network_network_info_size__SeZ2K {
  font-size: 1.2em;
}

.network_network_traffic_container__n70M4 {
  padding: 20px;
  background-color: #f1f1f1; /* 컨테이너 배경색 */
  width: 95%;
  border-radius: 5px;
  margin: auto;
}

.network_network_traffic_container__n70M4 span {
  width: 100%;
}

.network_network_traffic_container__n70M4 h2 {
  text-align: center;
  color: #006064; /* 헤더 텍스트 색상 */
}

.network_network_traffic_chart__5UM9G {
  max-width: 800px;
  margin: 0 auto;
}

.network_network_err_traffic_container__xhR4F {
  padding: 20px;
  background-color: #f1f1f1; /* 컨테이너 배경색 */
  width: 95%;
  border-radius: 5px;
  margin: auto;
}

.network_network_err_traffic_container__xhR4F span {
  width: 100%;
}

.network_network_err_traffic_container__xhR4F h2 {
  text-align: center;
  color: #3f0064; /* 헤더 텍스트 색상 */
}

.network_network_err_traffic_chart__c5KkW {
  max-width: 800px;
  margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/pages/Summary/network/network.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,yBAAA,EAAA,aAAA;EACA,UAAA;EACA,cAAA,EAAA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA,EAAA,cAAA;AACF;;AAEA;EACE,yBAAA,EAAA,WAAA;EACA,cAAA,EAAA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,0CAAA;EACA,0BAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAGA;EACE,aAAA;EACA,yBAAA,EAAA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;AAAF;;AAGA;EACE,WAAA;AAAF;;AAGA;EACE,kBAAA;EACA,cAAA,EAAA,cAAA;AAAF;;AAGA;EACE,gBAAA;EACA,cAAA;AAAF;;AAIA;EACE,aAAA;EACA,yBAAA,EAAA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;AADF;;AAIA;EACE,WAAA;AADF;;AAIA;EACE,kBAAA;EACA,cAAA,EAAA,cAAA;AADF;;AAIA;EACE,gBAAA;EACA,cAAA;AADF","sourcesContent":["// network ip\n.title {\n  text-align: center;\n}\n\n.network_info_container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  background-color: #595959; /* 컨테이너 배경색 */\n  width: 95%;\n  color: #ffffff; /* 텍스트 색상 */\n  padding: 20px;\n  border-radius: 5px;\n  margin: auto;\n}\n\n.network_info_container span {\n  width: 100%;\n}\n\n.network_info_container h2 {\n  text-align: center;\n  color: #ffffff; /* 헤더 텍스트 색상 */\n}\n\n.network_info_box {\n  background-color: #06B8F0; /* 박스 배경색 */\n  color: #ffffff; /* 텍스트 색상 */\n  padding: 10px;\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s;\n}\n\n.network_info_box:hover {\n  transform: scale(1.05);\n}\n\n.network_info_name {\n  font-weight: bold;\n  margin-bottom: 5px;\n}\n\n.network_info_size {\n  font-size: 1.2em;\n}\n\n// network traffic\n.network_traffic_container {\n  padding: 20px;\n  background-color: #f1f1f1; /* 컨테이너 배경색 */\n  width: 95%;\n  border-radius: 5px;\n  margin: auto;\n}\n\n.network_traffic_container span {\n  width: 100%;\n}\n\n.network_traffic_container h2 {\n  text-align: center;\n  color: #006064; /* 헤더 텍스트 색상 */\n}\n\n.network_traffic_chart {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n// network traffic\n.network_err_traffic_container {\n  padding: 20px;\n  background-color: #f1f1f1; /* 컨테이너 배경색 */\n  width: 95%;\n  border-radius: 5px;\n  margin: auto;\n}\n\n.network_err_traffic_container span {\n  width: 100%;\n}\n\n.network_err_traffic_container h2 {\n  text-align: center;\n  color: #3f0064; /* 헤더 텍스트 색상 */\n}\n\n.network_err_traffic_chart {\n  max-width: 800px;\n  margin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `network_title__otc5C`,
	"network_info_container": `network_network_info_container__J-lJ+`,
	"network_info_box": `network_network_info_box__ggnTC`,
	"network_info_name": `network_network_info_name__UfUPN`,
	"network_info_size": `network_network_info_size__SeZ2K`,
	"network_traffic_container": `network_network_traffic_container__n70M4`,
	"network_traffic_chart": `network_network_traffic_chart__5UM9G`,
	"network_err_traffic_container": `network_network_err_traffic_container__xhR4F`,
	"network_err_traffic_chart": `network_network_err_traffic_chart__c5KkW`
};
export default ___CSS_LOADER_EXPORT___;
